export * as Attempts from './Attempts'
export * as GetInsurances from './GetInsurances'
export * as GetPartnersQuote from './GetPartnersQuote'
export * as PostPartnerQuote from './PostPartnerQuote'
export * as WebContents from './WebContents'
export * as CheckInsurance from './CheckInsurance'
export * as SubscribeInsurance from './SubscribeInsurance'
